// extracted by mini-css-extract-plugin
export default {"divider":"Footer_divider__QprbL","footer":"Footer_footer__PxxIj","logo":"Footer_logo__w79hm"};